import React, { Component } from "react";
import { Accordion, Card } from "react-bootstrap";

import "./style.css";

import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import FadeIn from "react-fade-in";

export default class FAQPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div>
        <Header />
        <FadeIn>
          <div className="row h-100 w-100 ">
            <div className="col-sm-12 col-md-8 offset-md-2 my-auto pb-5">
              <div className="card shadow">
                <div className="card-header text-center">
                  <h4>Frequently Asked Questions (FAQs)</h4>
                </div>
                <div className="row">
                  <div className="col p-sm-5 py-3">
                    <Accordion>
                      <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="0">
                            <h5>
                            Q1. Who is able to get the vaccine provided by
                            Redlands Community Hospital?{" "}
                            </h5>
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="0">
                          <Card.Body>
                            <h5>
                              <span>
                                Group eligibility is identified by the SB Public
                                Health Department{" "}
                                <a
                                  href="https://sbcovid19.com/"
                                  rel="noreferrer"
                                  target="_blank"
                                >
                                  www.sbcovid19.com
                                </a>
                              </span>
                              <ul>
                                <li className="item">
                                  Must live or work in San Bernardino County
                                </li>
                                <li className="item">
                                  Must be able to commit to second dose at the
                                  time of the first dose
                                  <ul>
                                    <li className="pt-3">
                                      Pfizer second dose is 17-21 days after the
                                      first dose
                                    </li>
                                    <li className="pt-2">
                                      Moderna second dose is 28 days after the
                                      first dose
                                    </li>
                                  </ul>
                                </li>
                              </ul>{" "}
                            </h5>
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                      <Card>
                      <Accordion.Toggle as={Card.Header} eventKey="1">
                        <h5>Q2. What vaccine will I be given?</h5>

                          </Accordion.Toggle>
                        <Accordion.Collapse eventKey="1">
                          <Card.Body>
                            <h5>
                              <span>
                                Vaccines are provided as supplied by the county.
                                We are unable to schedule by manufacturer.
                              </span>
                            </h5>
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                      <Card>
                      <Accordion.Toggle as={Card.Header} eventKey="2">
                      <h5>
                                Q3. What should I consider before getting a
                                vaccine?
                              </h5>
                          </Accordion.Toggle>
                        <Accordion.Collapse eventKey="2">
                          <Card.Body>
                            <h5>
                              <span>
                                Talk to your doctor if you have questions
                                concerning the following:
                              </span>
                              <ul>
                                <li className="item">
                                  Have I had a severe allergic reaction after
                                  receiving another vaccine?
                                </li>
                                <li className="item">
                                  Am I planning to become pregnant or breastfeed
                                  in the next three months?
                                </li>
                              </ul>{" "}
                            </h5>
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                      <Card>
                      <Accordion.Toggle as={Card.Header} eventKey="3">
                      <h5>
                                Q4. If I have had COVID can I get the vaccine?
                              </h5>
                          </Accordion.Toggle>
                        <Accordion.Collapse eventKey="3">
                          <Card.Body>
                            <h5>
                              <span>
                                Yes, if you are out of your 10 day quarantine
                                period and are symptom-free, you can get the
                                vaccine. If you had infusion treatments for
                                COVID-19 in an emergency room or in the
                                hospital, you need to wait 90 days from
                                treatment to get the vaccine.
                              </span>
                            </h5>
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                      <Card>
                      <Accordion.Toggle as={Card.Header} eventKey="4">
                      <h5>
                                Q5. I had another vaccine within the last 14
                                days, can I get the COVID-19 vaccine?
                              </h5>
                          </Accordion.Toggle>
                        <Accordion.Collapse eventKey="4">
                          <Card.Body>
                            <h5>
                              <span>
                                It is not recommended to get the vaccine within
                                14 days of another vaccine. Please schedule out
                                of this 14 day window.
                              </span>
                            </h5>
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                      <Card>
                      <Accordion.Toggle as={Card.Header} eventKey="5">
                      <h5>
                                Q6. I have more questions where can I look for
                                more information about vaccines?
                              </h5>
                          </Accordion.Toggle>
                        <Accordion.Collapse eventKey="5">
                          <Card.Body>
                            <h5>
                              <ul>
                                <li className="item">
                                  <b>Moderna:</b>&nbsp;
                                  <a
                                    href="https://www.cdc.gov/coronavirus/2019-ncov/vaccines/different-vaccines/Moderna.html"
                                    rel="noreferrer"
                                    target="_blank"
                                  >
                                    https://www.cdc.gov/coronavirus/2019-ncov/vaccines/different-vaccines/Moderna.html
                                  </a>
                                </li>
                                <li className="item">
                                  <b>Pfizer:</b>&nbsp;
                                  <a
                                    href="https://www.cdc.gov/coronavirus/2019-ncov/vaccines/different-vaccines/Pfizer-BioNTech.html"
                                    rel="noreferrer"
                                    target="_blank"
                                  >
                                    https://www.cdc.gov/coronavirus/2019-ncov/vaccines/different-vaccines/Pfizer-BioNTech.html
                                  </a>
                                </li>
                              </ul>{" "}
                            </h5>
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                    </Accordion>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
        <Footer />
      </div>
    );
  }
}
